import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import config from '../../../config'
import {BASE_URL} from '../../../../api'
import API_LINKS from '../../../../constant/api.links'
// import {useGetSubAdminByIdQuery} from '../../../../../api'

const SubAdminDetails = ({}) => {
  const params = useParams()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()

  const {axios} = config

  const fullPath = params['*']

  const id = fullPath.split('/')[0]

  console.log(id, 'id')

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true)
        const API_URL = BASE_URL + API_LINKS.GET_SUBADMIN + '/' + id
        const {data} = await axios.get(API_URL)
        console.log(data, 'data-sub-admin')
        setData(data)
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    }

    if (id) {
      init()
    }
  }, [])
  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Sub Admin Details</h3>
          </div>

          {/* <Link to='/crafted/account/settings' className='btn btn-primary align-self-center'>
            Edit Profile
          </Link> */}
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Full Name</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{data?.name}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Email</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{data?.email}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Contact</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{data?.phone}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Country
              <i
                className='fas fa-exclamation-circle ms-1 fs-7'
                data-bs-toggle='tooltip'
                title='Country of origination'
              ></i>
            </label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{data?.country}</span>
            </div>
          </div>

          {/* <div className='row mb-7'>
        <label className='col-lg-4 fw-bold text-muted'>Communication</label>

        <div className='col-lg-8'>
          <span className='fw-bolder fs-6 text-dark'>Email</span>
        </div>
      </div> */}

          {/* <div className='row mb-10'>
        <label className='col-lg-4 fw-bold text-muted'>Allow Changes</label>

        <div className='col-lg-8'>
          <span className='fw-bold fs-6'>Yes</span>
        </div>
      </div> */}

          {/* <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
        <KTSVG
          path='icons/duotune/general/gen044.svg'
          className='svg-icon-2tx svg-icon-warning me-4'
        />
        <div className='d-flex flex-stack flex-grow-1'>
          <div className='fw-bold'>
            <h4 className='text-gray-800 fw-bolder'>We need your attention!</h4>
            <div className='fs-6 text-gray-600'>
              Your payment was declined. To start using tools, please
              <Link className='fw-bolder' to='/crafted/account/settings'>
                {' '}
                Add Payment Method
              </Link>
              .
            </div>
          </div>
        </div>
      </div> */}
        </div>
      </div>

      <div className='row gy-10 gx-xl-10'>
        <div className='col-xl-6'>
          {/* <ChartsWidget1 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>

        <div className='col-xl-6'>
          {/* <TablesWidget1 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>
      </div>

      <div className='row gy-10 gx-xl-10'>
        <div className='col-xl-6'>
          {/* <ListsWidget5 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>

        <div className='col-xl-6'>
          {/* <TablesWidget5 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>
      </div>
    </>
  )
}

export default SubAdminDetails
